

















import Vue from 'vue';
import Component from 'vue-class-component';

/** FooterWrapper is a component used to display a Footer */
@Component
export default class FooterWrapper extends Vue {}
